import type {CSSProperties, ReactNode} from 'react';

import {AnimatedDialog} from '../shared/AnimatedDialog';

export type ModalProps = {
  show: boolean;
  onClose?: () => void;
  canceledOnTouchOutside?: boolean;
  canceledOnTouchInside?: boolean;
  children?: ReactNode;
  contentStyle?: CSSProperties;
  headerStyle?: CSSProperties;
  footerStyle?: CSSProperties;
  header?: ReactNode;
  footer?: ReactNode | null;
  defaultHeader?: boolean;
  /** Shows the close (×) button in the default header. Default: true */
  showCloseButton?: boolean;
  title?: string;
  fullScreen?: boolean;
  className?: string;
};

export function Modal({fullScreen = false, ...props}: ModalProps) {
  return <AnimatedDialog {...props} panelMode={fullScreen ? 'fullscreen' : 'center'} />;
}
